import { signInWithCustomToken, type User } from 'firebase/auth';
import { auth } from './firebase';

export type ProjectAuthRole = 'customer' | 'admin';

export interface ProjectAuthClaims {
  role: ProjectAuthRole;
  email?: string;
  jiraKey?: string;
}

export async function signInWithProjectToken(customToken: string): Promise<User> {
  const credential = await signInWithCustomToken(auth, customToken);
  return credential.user;
}

export async function getProjectAuthClaims(
  user: User | null = auth.currentUser,
): Promise<ProjectAuthClaims | null> {
  if (!user) {
    return null;
  }

  const tokenResult = await user.getIdTokenResult();
  const role = tokenResult.claims.role;
  if (role !== 'customer' && role !== 'admin') {
    return null;
  }

  return {
    role,
    email: typeof tokenResult.claims.email === 'string' ? tokenResult.claims.email : undefined,
    jiraKey: typeof tokenResult.claims.jiraKey === 'string' ? tokenResult.claims.jiraKey : undefined,
  };
}

export async function userCanAccessProject(jiraKey: string, user: User | null = auth.currentUser): Promise<boolean> {
  const claims = await getProjectAuthClaims(user);
  if (!claims) {
    return false;
  }
  if (claims.role === 'admin') {
    return true;
  }
  return claims.role === 'customer' && claims.jiraKey === jiraKey;
}
